// extracted by mini-css-extract-plugin
export default {"main":"InstaConnectForm_main__QFsNb","spinner":"InstaConnectForm_spinner__i5Q8c","content":"InstaConnectForm_content__HtaUa","error":"InstaConnectForm_error__4Rjfx"};